{
	"name": "agathe-you-web",
	"version": "179.1",
	"author": "CBA",
	"homepage": "https://cbainfo.fr/",
	"scripts": {
		"branch": "node scripts/submodule-branch.creator.js",
		"branch:sync": "node scripts/projects.synchronizer.js",
		"tag:sync": "node scripts/tag.updater.js",
		"ng": "ng",
		"start": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng serve",
		"start:aot": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng serve --project app",
		"start:prod": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng serve --configuration=prod",
		"start:preprod": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng serve --configuration=preprod",
		"build": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng build",
		"build:emotion": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng build --deploy-url http://localhost:4200/",
		"build:emotion:watch": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng build --deploy-url http://localhost:4200/ --watch",
		"build:emotion:preprod:watch": "cross-env NODE_OPTIONS=--max-old-space-size=16384 ng build --configuration=preprod --deploy-url http://localhost:4200/ --watch",
		"build:prod": "cross-env NODE_OPTIONS=--max-old-space-size=24384 ng build --configuration=prod",
		"build:preprod": "cross-env NODE_OPTIONS=--max-old-space-size=24384 ng build --configuration=preprod",
		"build:qualif": "cross-env NODE_OPTIONS=--max-old-space-size=24384 ng build --configuration=qualif",
		"postbuild": "npm run prefixed-css && npm run ng-postbuild",
		"postbuild:prod": "npm run prefixed-css && npm run ng-postbuild",
		"postbuild:qualif": "npm run prefixed-css && npm run ng-postbuild",
		"postbuild:preprod": "npm run prefixed-css && npm run ng-postbuild",
		"ng-postbuild": "node buildscript/postbuild.js",
		"d:postbuild": "docker exec ay-angular npm run prefixed-css && npm run ng-postbuild",
		"prefixed-css": "bash ./buildscript/build-prefixed-styles.sh",
		"prepare": "husky",
		"prettier": "prettier **/*.{html,css,sass,scss,json,js,ts,jsx,tsx,cjs,cts,mjs,mts,vue,yml,xml} -w -u",
		"postinstall": "dev-config",
		"sentry:sourcemaps:inject": "sentry-cli sourcemaps inject ./www",
		"sentry:sourcemaps:upload": "sentry-cli sourcemaps upload ./www",
		"sentry:sourcemaps:process": "npm run sentry:sourcemaps:inject && npm run sentry:sourcemaps:upload",
		"sentry:info": "sentry-cli info",
		"clean:sourcemaps": "rm -rf www/**/*.{js,css}.map"
	},
	"private": true,
	"browserslist": [
		"> 5%"
	],
	"dependencies": {
		"@angular-devkit/core": "^20.3.16",
		"@angular-devkit/schematics": "^20.3.16",
		"@angular-devkit/schematics-cli": "^17.3.5",
		"@angular/animations": "^20.3.16",
		"@angular/cdk": "^20.2.14",
		"@angular/common": "^20.3.16",
		"@angular/core": "^20.3.16",
		"@angular/forms": "^20.3.16",
		"@angular/material": "^20.2.14",
		"@angular/platform-browser": "^20.3.16",
		"@angular/platform-browser-dynamic": "^20.3.16",
		"@angular/router": "^20.3.16",
		"@ionic/angular": "^7.8.6",
		"@ionic/core": "^7.8.6",
		"@ionic/storage": "^3.0.4",
		"@ionic/storage-angular": "^4.0.0",
		"@jack-sparrow-libraries/angular-business-commons": "1.2.0-173",
		"@jack-sparrow-libraries/angular-business-coordination": "6.0.0-bundled-main.31",
		"@jack-sparrow-libraries/dev-config": "1.0.5",
		"@jack-sparrow-libraries/emotion-models": "2.4.1",
		"@jack-sparrow-libraries/facture-electronique": "0.1.0",
		"@jack-sparrow-libraries/lib-agathe-link": "0.17.2",
		"@jack-sparrow-libraries/sd-figma": "3.0.2",
		"@jack-sparrow-libraries/store": "2.0.0-bundled-dev.6.3",
		"@jack-sparrow-libraries/ui-kit": "12.0.0",
		"@jack-sparrow-libraries/upload-scor": "2.0.0-bundled.4",
		"@lottiefiles/lottie-player": "^1.7.1",
		"@meddv/ngx-pinch-zoom": "^17.0.1",
		"@ngneat/input-mask": "^6.1.0",
		"@ngrx/effects": "^20.1.0",
		"@ngrx/entity": "^20.1.0",
		"@ngrx/operators": "^20.1.0",
		"@ngrx/schematics": "^20.1.0",
		"@ngrx/store": "^20.1.0",
		"@ngrx/store-devtools": "^20.1.0",
		"@sentry/angular": "^9.2.0",
		"@sentry/cli": "^2.42.2",
		"axios": "^0.21.4",
		"chart.js": "^4.5.1",
		"compare-func": "^2.0.0",
		"cross-env": "^7.0.3",
		"date-fns": "^2.29.1",
		"deep-diff": "^1.0.2",
		"dwt": "^18.1.1",
		"es6-promise-plugin": "^4.2.2",
		"inputmask": "^5.0.8",
		"jszip": "^3.10.1",
		"jwt-decode": "^4.0.0",
		"lodash-es": "^4.17.21",
		"moment": "^2.29.4",
		"ng2-charts": "^6.0.1",
		"ngx-dropzone": "^3.1.0",
		"ngx-image-cropper": "^6.2.2",
		"ngx-infinite-scroll": "^17.0.0",
		"ngx-toastr": "^17.0.2",
		"pdfjs-dist": "^4.8.69",
		"posthog-js": "^1.291.0",
		"rxjs": "^7.5.0",
		"swiper": "^12.1.3",
		"tailwindcss-scoped-preflight": "3.5.7",
		"tslib": "^2.4.0",
		"tw-elements": "^1.0.0-alpha12",
		"uuid": "^9.0.0",
		"zone.js": "^0.15.1"
	},
	"devDependencies": {
		"@angular-devkit/architect": "^0.2003.16",
		"@angular-devkit/build-angular": "^20.3.16",
		"@angular/cli": "^20.3.16",
		"@angular/compiler": "^20.3.16",
		"@angular/compiler-cli": "^20.3.16",
		"@angular/language-service": "^20.3.16",
		"@ionic/angular-toolkit": "^9.0.0",
		"@types/chart.js": "^2.9.37",
		"@types/inputmask": "5.0.0",
		"@types/jasmine": "~3.6.0",
		"@types/jasminewd2": "~2.0.3",
		"@types/lodash-es": "^4.17.12",
		"@types/node": "^12.20.55",
		"autoprefixer": "^10.4.7",
		"enquirer": "^2.4.1",
		"ini": "^5.0.0",
		"jasmine-core": "~3.7.1",
		"jasmine-spec-reporter": "~5.0.0",
		"jsdom": "^26.1.0",
		"karma": "^6.4.0",
		"karma-chrome-launcher": "~3.1.0",
		"karma-coverage": "~2.0.3",
		"karma-coverage-istanbul-reporter": "~3.0.2",
		"karma-jasmine": "~4.0.0",
		"ng-packagr": "^20.3.2",
		"postcss": "^8.4.14",
		"postcss-cli": "^10.0.0",
		"postcss-scss": "^4.0.4",
		"tailwindcss": "^3.2.4",
		"ts-node": "~8.3.0",
		"typescript": "~5.8.3"
	},
	"description": "An project",
	"overrides": {
		"@jack-sparrow-libraries/angular-business-commons": {
			"@angular/common": "$@angular/common",
			"@angular/core": "$@angular/core",
			"@ngrx/store": "$@ngrx/store"
		},
		"@jack-sparrow-libraries/facture-electronique": {
			"@jack-sparrow-libraries/sd-figma": "$@jack-sparrow-libraries/sd-figma",
			"@jack-sparrow-libraries/ui-kit": "$@jack-sparrow-libraries/ui-kit"
		},
		"@jack-sparrow-libraries/emotion-models": {
			"@angular/common": "$@angular/common",
			"@angular/core": "$@angular/core",
			"@ngrx/store": "$@ngrx/store"
		},
		"@jack-sparrow-libraries/lib-agathe-link": {
			"@angular/core": "$@angular/core",
			"@angular/common": "$@angular/common"
		},
		"@meddv/ngx-pinch-zoom": {
			"@angular/core": "$@angular/core",
			"@angular/common": "$@angular/common"
		},
		"@ngrx/effects": {
			"@angular/core": "$@angular/core"
		},
		"@ngrx/entity": {
			"@angular/core": "$@angular/core"
		},
		"@ngrx/store": {
			"@angular/core": "$@angular/core"
		},
		"ngx-infinite-scroll": {
			"@angular/core": "$@angular/core",
			"@angular/common": "$@angular/common"
		},
		"ng-packagr": {
			"@angular/compiler-cli": "$@angular/compiler-cli"
		},
		"@jack-sparrow-libraries/ay-models": {
			"@angular/common": "$@angular/common",
			"@angular/core": "$@angular/core",
			"@ngrx/store": "$@ngrx/store"
		},
		"angular-svg-icon": {
			"@angular/core": "$@angular/core",
			"@angular/common": "$@angular/common"
		}
	}
}
